import type { Dispatch, SetStateAction } from 'react'

import { axiosClient } from '../../../services/axiosInstance'
import { OrderForm } from '../entity/orderForm'

export const useClientProfile = (
  orderForm: OrderForm,
  setOrderForm: Dispatch<SetStateAction<OrderForm>>
) => {
  const checkGuestCheckout = async ({ email }: { email: string }) => {
    try {
      const { data } = await axiosClient.post(
        `/api/checkout/orderForm/${orderForm.orderFormId}/attachments/clientProfileData`,
        { email },
        { headers: { 'Content-Type': 'application/json' } }
      )

      if (!data || !data.orderFormId) {
        console.error('Invalid response from guest checkout API')

        return null
      }

      const updatedOrderForm = new OrderForm(data)

      setOrderForm(updatedOrderForm)

      return updatedOrderForm
    } catch (error) {
      console.error('Error checking guest checkout:', error)

      return null
    }
  }

  return { checkGuestCheckout }
}
